import { Injectable } from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {BaseDatabaseService} from '../BaseDatabaseService';
import {EmailTable} from '../../../classes/EmailTable';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type':  'application/json'
      // 'Authorization': 'my-auth-token'
    }
  )
};

@Injectable({
  providedIn: 'root'
})
export class EmailTableService extends BaseDatabaseService {

  private collectionName = 'emailMessage';

  constructor() {
    super();
  }

  getAll() {
    return this.db.collection(this.collectionName).get();
  }

  getOne(id) {
    return this.db.collection(this.collectionName).doc(id).get();
  }

  save(id, email: EmailTable[]) {
    const arr = email.map( item => Object.assign({}, item) );
    const data = {emails : arr};
    return this.db.collection(this.collectionName).doc(id).set(data);
  }
}
